import * as types from './mutations-types'

export default {
  [types.MY_RECORD_DATA] (state, data) {
    state.goOutMyRecordData = data
  },
  [types.CANCEL_RECORD_LIST] (state, data) {
    let compare = function () {
      return function (objAfter, objBefore) {
        let val1 = objAfter['id']
        let val2 = objBefore['id']
        return val2 - val1
      }
    }
    state.cancelRecordList = data.sort(compare())
  },
  [types.UPDATE_COUPON_INFO_RECORD] (state, data) {
    state.cancelRecordList = state.cancelRecordList.map(item => {
      if (item.id === data.id) {
        item.state = true
      }
      return item
    })
  },
  [types.UPDATE_COUPON_INFO_FALSE_RECORD] (state, data) {
    state.cancelRecordList = state.cancelRecordList.map(item => {
      if (item.id === data.id) {
        item.state = false
      }
      return item
    })
  },
  [types.GET_COUPON_DETAIL] (state, data) {
    state.couponDetailById = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/store/mutations.js